/** API URL STARTS*/
import { Typography } from "@deere/fuel-react";
import {getAmountCell, getCurrencyCell, getDateCell, getStatusCell } from "../utils/utils";
import AssignmentNumberCell from "../common/AssignmentNumberCell";
import dayjs from "dayjs";
import { getGridStringOperators } from '@mui/x-data-grid-pro';

const HOST_URL = process.env.REACT_APP_API_URL;
const BN_HOST_URL = process.env.REACT_APP_BN_API_URL;

//const HOST_URL="http://localhost:8080";
//const BN_HOST_URL = "http:/s/localhost:8081"

export const API_ROOT = `${HOST_URL}/api`;

export const EXTENSION_APP = `${API_ROOT}/extension`;
export const USER_INFO_URI = `${API_ROOT}/user`;
export const EXTENSION_URI = `${API_ROOT}/extension/requestExtension`;
export const DROPDOWNS_URI = `${API_ROOT}/domainData`;
export const EXTENSION_SAVE_BP = `${API_ROOT}/extension/updateExtensionRequestForBP`;
export const EXTENSION_SAVE_CCM = `${API_ROOT}/extension/updateExtensionRequestForCCM`;
export const EXTENSION_APPROVE = `${API_ROOT}/extension/approve`;
export const EXTENSION_REJECT = `${API_ROOT}/extension/reject`;
export const EXTENSION_SEND_TO_CCM = `${API_ROOT}/extension/sendToCcm`;
export const EXTENSION_SEND_TO_BP = `${API_ROOT}/extension/sendToBP`;
export const EXTENSION_DOCUMENTS_URI = `${API_ROOT}/extension/getArchieveLinksFromSAP`;
export const LOG_SEARCH_FILTER = `${API_ROOT}/extension/searchLogs`;

// Manual Request APIs
export const MANUAL_REQUEST_LIST = `${API_ROOT}/manualRequest/list`;
export const MANUAL_REQUEST_DELETE = `${API_ROOT}/manualRequest/delete`;
export const MANUAL_REQUEST_OPEN_ITEMS = `${API_ROOT}/manualRequest/openItems`;
export const MANUAL_REQUEST_SAVE = `${API_ROOT}/manualRequest/savemanualrequest`;
export const MANUAL_REQUEST_BASE_CODE = `${API_ROOT}/manualRequest/baseCode`;
export const MANUAL_REQUEST_CONFIRM = `${API_ROOT}/manualRequest/confirm`;
export const MANUAL_REQUEST_TEMPLATE = `${API_ROOT}/manualRequest/template`;
export const MANUAL_REQUEST_UPLOAD = `${API_ROOT}/manualRequest/upload`;
export const MANUAL_REQUEST_DROPDOWNS = {
  companyCodes: [
    { value: "4N00", label: "4N00" },
    { value: "4100", label: "4100" },
  ],
  financingTypes: [
    { value: "Leasing", label: "Leasing" },
    { value: "JDF", label: "JDF" },
  ],
};

export const ADD_PRODUCT_TYPE = `${API_ROOT}/addProductType`;
export const PRODUCT_TYPE_URI = `${API_ROOT}/productType`;
export const DELETE_PRODUCT_TYPE = `${API_ROOT}/deleteProductTypes`;
export const UPDATE_PRODUCT_TYPE = `${API_ROOT}/updateProductType`;
export const ADD_DEALER_DETAILS = `${API_ROOT}/addCustomerData`;
export const DEALER_DETAILS_URI = `${API_ROOT}/customerData`;
export const DELETE_DEALER_DETAILS = `${API_ROOT}/deleteCustomerData`;
export const UPDATE_DEALER_DETIALS = `${API_ROOT}/updateCustomerData`;
export const UPDATE_COUNTRIES_DETIALS = `${API_ROOT}/addUserCountries`;
export const DIRECT_DEBIT_CUSTOMER_DATA = `${API_ROOT}/directDebitCustomerData`;
export const ADD_DIRECT_DEBIT_CUSTOMER_DATA = `${API_ROOT}/addDirectDebitCustomerData`;
export const DELETE_DIRECT_DEBIT_CUSTOMER_DATA = `${API_ROOT}/deleteDirctDebitCustomerData`;
export const GET_ROLE_MANAGEMENT_DATA = `${API_ROOT}/getUserList`;
export const USER_PREFERENCE = `${API_ROOT}/getUserPreferenceDetails`;
export const UPDATE_USER_PREFERENCE = `${API_ROOT}/updateUserPreference`;
export const UPDATE_DASHBOARD_PREFERENCE = `${API_ROOT}/updateDashboardCountryPreference`;
export const UPDATE_DEALER_PREFERENCE = `${API_ROOT}/updateDealerPreference`;
export const UPLOAD_FILE = `${EXTENSION_APP}/upload`;
export const NOTIFICATION_API = `${API_ROOT}/notifications`;
export const LAST_FILE_UPLOAD = `${EXTENSION_APP}/bankFinancingDataUpdates`;

export const DASHBOARD = `${API_ROOT}/dashboard`;
export const CCM_DASHBOARD_MONTHLY_EXTENSION_REPORT = `${DASHBOARD}/ccm/monthlyExtensionReport`;
export const CCM_DASHBOARD_AUTO_APPROVAL_RATE = `${DASHBOARD}/ccm/autoApprovalRate`;
export const CCM_DASHBOARD_DEALER = `${DASHBOARD}/ccm/dealers`;
export const CCM_DASHBOARD_DEALER_TRENDS = `${DASHBOARD}/ccm/dealerTrends`;
export const ADMIN_IB_TASKS_PROGRESS = `${DASHBOARD}/admin/ibTasksProgress`;

export const IB_APP = `${API_ROOT}/ib`;
export const IB_BKP_DATES = `${IB_APP}/getDates`;
export const IB_BKP_GET_RATES = `${IB_APP}/bankrates`;
export const IB_BKP_EDIT_RATES = `${IB_APP}/editBankrates`;
export const IB_BKP_FRZ_RATES = `${IB_APP}/freezeBankRates`;
export const IB_DEALER_LIST = `${API_ROOT}/ib-ccm/getParentData`;
export const IB_DEALER_RC = `${API_ROOT}/ib-ccm/getChildData`;
export const IB_DEALER_EDIT = `${API_ROOT}/ib-ccm/editRate`;
export const IB_CCM_LOCK = `${API_ROOT}/ib-ccm/freezeRates`;
export const IB_CCM_UNLOCK = `${API_ROOT}/ib-ccm/unFreezeRates`;
export const IB_CCM_Domain_Data = `${API_ROOT}/ibCCMDomainData`;

export const IB_BP_RATE_STATUS_LIST = `${IB_APP}/allFreeze`;
export const IB_BP_RATE_FREEZE = `${IB_APP}/lockBPRates`;
export const IB_FISCAL_DATES = `${API_ROOT}/bpDomainData`;

export const IB_GET_MACHINES = `${IB_APP}/machineExceptions`;
export const IB_ADD_MACHINES = `${IB_APP}/addMachineDetails`;
export const IB_EDIT_MACHINES = `${IB_APP}/editMachineDetails`;
export const IB_DELETE_MACHINES = `${IB_APP}/deleteMachineDetails`;
export const IB_CUST_RATETYPE_LIST = `${IB_APP}/customRates`;
export const IB_EDIT_CUST_RATES = `${IB_APP}/editCustomRates`;

export const IB_CALCULATION_DOMAINDATA = `${API_ROOT}/ibDomainData`;
export const IB_CALCULATION_GETDATA = `${IB_APP}/calculationPage`;
export const IB_CALCULATION_SAVE = `${IB_APP}/updateIbRequestCalculation`;
export const IB_CALCULATION_EXCLUDE = `${IB_APP}/exclude`;
export const IB_CALCULATION_INCLUDE = `${IB_APP}/include`;
export const IB_POST_CALCULATION = `${IB_APP}/sapPostBapiCall`;
export const IB_CHECKED_CALCULATION = `${IB_APP}/bpChecked`;
export const IB_CALCULATION_REASONCODES = `${IB_APP}/getReasonCodeRates`;
export const IB_CALC_SCHEDULER_STATUS = `${IB_APP}/getCalculationSchedulerStatus`;
export const IB_PDF_DOWNLOAD = `${IB_APP}/downloadFile`;
export const IB_LOGS_DOWNLOAD = `${IB_APP}/exportData`;
export const IB_All_DOWNLOAD = `${IB_APP}/exportAllData`;

export const IB_SAP_CALLBY_ASSIGNMENT = `${IB_APP}/sapIBCallAssignment`;
export const REPORT = `${API_ROOT}/report`;
export const IB_GET_REPORT = `${REPORT}/bankratesReports`;
export const IB_GET_DEALER_REPORT = `${REPORT}/dealerReports`;
export const IB_GET_REPORT_FISMONTH = `${REPORT}/bankratesReportsBasedOnFiscalMonth`;
export const IB_GET_DEALER_REPORT_FISMONTH = `${REPORT}/dealerReportsWithinFisMonth`;
export const EXT_GET_MONTHLY_EXTENSION_REPORT = `${REPORT}/monthlyExtensionReport`;
export const EXT_GET_MONTHLY_EXTENSION_REPORT_FILTERS = `${REPORT}/monthlyExtensionReportByFilters`;
export const EXT_GET_MONTHLY_EXTENSION_IEEFTI_REPORT = `${REPORT}/monthlyExtensionIEEFTIReport`;
export const EXT_GET_MONTHLY_EXTENSION_IEEFTI_REPORT_FILTERS = `${REPORT}/monthlyExtensionIEEFTIReportByFilters`;
export const REPORT_CUSTOMER_INTEREST_DRILLDOWN_YEAR = `${REPORT}/fetchInterestDetailsYear`;
export const REPORT_CUSTOMER_INTEREST_DOMAIN_DATA = `${REPORT}/fetchInterestDetails`;

export const BN_APP = `${BN_HOST_URL}/billnow`;
export const BN_ARCHIVE_DOCUMENTS_URI = `${BN_HOST_URL}/billnow/archive/getArchieveLinksFromSAP`;

/** API URL ENDS*/

/** Route Constants start */

export const ROUTE_APP_HOME = "/";
export const ROUTE_OKTA_CALLBACK = "/login/callback";
export const ROUTE_EXTENSION = "/extension";
export const ROUTE_HOME = "/extension/home";
export const ROUTE_EXTENSION_BP = "/extension/business-process";
export const ROUTE_EXTENSION_JDF = "/extension/jdf";
export const ROUTE_EXTENSION_LOGS = "/extension/logs";
export const ROUTE_EXTENSION_ERRORS = "/extension/errors";
export const ROUTE_EXTENSION_MANUAL_REQUEST = "/extension/manual-request";

export const ROUTE_REPORT = "/report";
export const ROUTE_REPORT_BANK = "/report/bankRateReport";
export const ROUTE_REPORT_DEALER = "/report/dealerReport";
export const ROUTE_REPORT_MONTHLY_EXTENSION = "/report/monthlyExtensionReport";
export const ROUTE_REPORT_MONTHLY_EXTENSION_IEEFTI =
  "/report/monthlyExtensionIEEFTIReport";
export const ROUTE_REPORT_CUSTOMER_INTEREST_DRILLDOWN =
  "/report/customerInterestDrilldown";

export const ROUTE_DATA_MANAGEMENT = "/dataManagement";
export const ROUTE_DM = "/dataManagement/data-management";

export const ROUTE_DASHBOARD_BP = "/dashBoardBP";
export const ROUTE_DASHBOARD_ADMIN = "/dashBoardAdmin";
export const ROUTE_DASHBOARD_CCM = "/dashBoardCCM";

export const ROUTE_IB = "/interestBearing";
export const ROUTE_IB_BKP = "/interestBearing/bankPersonal";
export const ROUTE_IB_CCM = "/interestBearing/ratesAllocation";
export const ROUTE_IB_BP = "/interestBearing/ratesDashboard";

export const ROUTE_IB_CACLC = "/interestBearing/calculationsPage";

export const ROUTE_BN = "/billnow";
export const ROUTE_BN_ERROR = "/billnow/review-and-approve";
export const ROUTE_BN_ACCOUNTING = "/billnow/accounting-approval";
export const ROUTE_BN_SUCESS = "/billnow/successful-transactions";
export const ROUTE_BN_UPLOAD = "/billnow/upload-monthly-debits";
export const STORED_ROUTE_EXT = "stored_route_ext";
export const STORED_ROUTE_IB = "stored_route_ib";
export const STORED_ROUTE_DM = "stored_route_dm";
export const STORED_ROUTE_REPORT = "stored_route_report";
export const VALID_ROUTES = [
  ROUTE_DASHBOARD_BP,
  ROUTE_DASHBOARD_ADMIN,
  ROUTE_DASHBOARD_CCM,
  ROUTE_EXTENSION_BP,
  ROUTE_EXTENSION_JDF,
  ROUTE_EXTENSION_LOGS,
  ROUTE_EXTENSION_ERRORS,
  ROUTE_DM,
  ROUTE_REPORT,
  ROUTE_IB_BKP,
  ROUTE_IB_CCM,
  ROUTE_IB_BP,
  ROUTE_IB_CACLC,
  ROUTE_BN,
  ROUTE_BN_ERROR,
  ROUTE_BN_ACCOUNTING,
  ROUTE_BN_UPLOAD,
  ROUTE_BN_SUCESS,
  ROUTE_REPORT_BANK,
  ROUTE_REPORT_DEALER,
  ROUTE_REPORT_MONTHLY_EXTENSION,
  ROUTE_REPORT_MONTHLY_EXTENSION_IEEFTI,
  ROUTE_REPORT_CUSTOMER_INTEREST_DRILLDOWN,
];

/** Route Constants end */

/** OKTA CONSTANTS START */

const OKTA_SCOPES = [
  "openid",
  "email",
  "profile",
  "authorities",
  "jduadminadgroups",
];

export const OKTA_CONFIG = {
  clientId: process.env.REACT_APP_CLIENT_ID,
  issuer: process.env.REACT_APP_OKTA_AUTH_URL,
  pkce: true,
  redirectUri: process.env.REACT_APP_OKTA_REDIRECT_URI + ROUTE_OKTA_CALLBACK,
  scopes: OKTA_SCOPES,
  tokenManager: {
    autoRenew: true,
    autoRemove: false,
    syncStorage: true,
  },
};

export const otherThanJDWINCountries = ["FR", "DE", "IE", "IT", "ES", "PT", "PL", "GB"];


export const REQUEST_STATUS = {
  system_bp: "system_bp",
  system_ccm: "system_ccm",
  bp_to_ccm: "bp_to_ccm",
  ccm_to_bp: "ccm_to_bp",
  system_reject: "system_reject",
  ccm_reject: "ccm_reject",
  system_rejected_by_ccm: "system_rejected_by_ccm",
  system_approved: "system_approved",
  bp_approved: "bp_approved",
  ccm_approved: "ccm_approved",
  system_approved_by_bp: "system_approved_by_bp",
  error: "error",
  not_processed_by_fs: "not_processed_by_fs",
  bp_reject: "bp_reject",
  system_include: "system_include",
  system_exclude: "system_exclude",
  system_bp_include: "system_bp_include",
  system_bp_exclude: "system_bp_exclude",
  bp_booked: "bp_booked",
  not_processed_by_fs_bp: "not_processed_by_fs_bp",
  system_include_exclude: "system_include_exclude",
  system_exclude_include: "system_exclude_include",
  auto_approved: "auto_approved",
  manual_new: "manual_new",
  manual_error: "manual_error",
  pending: "pending",
};
export const OKTA_STORAGE_TOKEN = "okta-token-storage";

/** OKTA CONSTANTS ENDS */

/** Table CONSTANTS STARTS */

export const COMMON_RECORD = [
  [
    "reasonCode",
    "accountingDocNo",
    "originalDueDate",
    "originalDocDate",
    "docType",
    "reasonForCheck",
  ],
  [
    "newReasonCode",
    "amountToExtend",
    "newCalculatedDate",
    "daysOfExtension",
    "itemTextForExtendedAmount",
    "rvAmountInDocCurrency",
    "longTextForDocLineItem",
  ],
  ["serialNo", "baseCode", "comarNumber", "retailSoldDate", "presoldDate"],
];

export const RECORD_DETAILS_STRUCTURE = [
  [
    "reasonCode",
    "accountingDocNo",
    "originalDueDate",
    "originalDocDate",
    "docType",
    "downPaymentAmount",
    "reasonForCheck",
    "userID",
  ],
  [
    "newReasonCode",
    "amountToExtend",
    "newCalculatedDate",
    "daysOfExtension",
    "itemTextForExtendedAmount",
    "rvAmountInDocCurrency",
    "itemText",
    "longTextForDocLineItem",
  ],
  [
    ...COMMON_RECORD[2],
    "commentFromBP",
    "commentSendToBP",
    "commentSendToDealer",
    "valuta",
  ],
];

export const RECORD_DETAILS_STRUCTURE_CCM = [
  [
    "reasonCode",
    "accountingDocNo",
    "originalDueDate",
    "originalDocDate",
    "docType",
    "commentFromBP",
    "reasonForCheck",
  ],
  [
    "newReasonCode",
    "newCalculatedDate",
    "amountToExtend",
    "daysOfExtension",
    "downPaymentPercentage",
    "downPaymentAmount",
    "itemTextForExtendedAmount",
    "rvAmountInDocCurrency",
    "longTextForDocLineItem",
  ],
  [...COMMON_RECORD[2], "itemText", "userName", "commentSendToDealer", "commentSendToBP", "valuta"],
];

export const CALCULATION_RECORD_DETAILS_STRUCTURE = [
  [
    "docDateInDoc",
    "dueDateOfInvoice",
    "itemText",
    "businessArea",
    "cancelledDebitNoteNumber",
    "creditNoteNumber",
  ],
  ["reasonCodeForPayment", "previousReasonCode", "startDate", "endDate"],
  [
    "calculatedInterest",
    "interestPercentage",
    "noOfDays",
    "docNoOfClearingDoc",
    "clearingDate",
    "machineExceptionComments",
  ],
];

export const CALCULATION_RECORD_COMMENTS_STRUCTURE = ["reasonForCheck"];

export const CALCULATION_EDITABLE_FIELDS = {
  previousReasonCode: {
    type: "select",
  },
  startDate: {
    editable: true,
    type: "date",
    validation: { max: ["endDate"] },
    errorMsg: {
      max: "Start date cannot be after end date",
    },
  },
  endDate: {
    editable: true,
    type: "date",
    validation: { min: ["startDate"] },
    errorMsg: {
      min: "End date cannot be before start date",
    },
  },
  noOfDays: {
    editable: false,
    type: "number",
  },
  calculatedInterest: {
    editable: false,
    type: "number",
  },
  interestPercentage: {
    editable: false,
    type: "number",
  },
};

export const APP_VIEW = {
  BP: "BP_VIEW",
  CCM: "CCM_VIEW",
  LOGS: "LOG_VIEW",
  ERRORS: "ERROR_VIEW",
  DM: "DATA_MANAGEMENT_VIEW",
  UPLOAD: "FILE_UPLOAD",
  BKP: "BKP",
  IB_BP: "IB_BP",
  BP_CHECK: "bp_check",
  INCLUDE: "include",
  EXCLUDE: "exclude",
  IB_LOGS: "logs",
};

export const APP_ACTIONS = {
  APPROVE: "approve",
  REJECT: "reject",
  SENDTOCCM: "sendToCcm",
  SENDTOBP: "sendToBp",
  DELETEPRODUCT: "deleteProduct",
  DELETEDEALER: "deleteDealer",
  DELETEDIRECTDEBITDEALER: "deleteDirectDebitDealer",
  DELETEMACHINE: "deleteMachine",
  BOOKINTEREST: "bookInterest",
  DOWNLOAD_LOGS: "DOWNLOAD_LOGS",
  DOWNLOADAll_LOGS: "DOWNLOADAll_LOGS",
  CANCELLEDDEBITNOTE: "cancelDebitNote",
};

export const ROLES = {
  BP: "BP",
  CCM: "CCM",
  ADMIN: "ADMIN",
  BKP: "BKP",
  BN_ADMIN: "BN_ADMIN",
  JDU_ADMIN: "JDU_ADMIN",
  BN_USER: "BN_USER",
};

export const MANUAL_REQUEST_VIEW_ROLES = [ROLES.BP, ROLES.CCM, ROLES.ADMIN];
export const MANUAL_REQUEST_ACTION_ROLES = [ROLES.BP, ROLES.CCM];

export const TRANSLATIONS = {
  EXTENSION: "extension",
  INTEREST_BEARING: "interest-bearing",
  DATA_MANAGEMENT: "data-management",
  REPORT: "report",
  GLOBAL: "global",
  BILLNOW: "billNow",
};

export const DETAILS_FIELD_FORMATTING = {
  downPaymentPercentage: { type: "custom", value: "%" },
  downPaymentAmount: { type: "amount" },
  amountToExtend: { type: "amount" },
  rvAmountInDocCurrency: { type: "amount" },
  newCalculatedDate: { type: "date" },
  retailSoldDate: { type: "date" },
  presoldDate: { type: "date" },
  originalDueDate: { type: "date" },
  originalDocDate: { type: "date" },
  valuta: { type: "date" },
  startDate: { type: "date" },
  endDate: { type: "date" },
};


export const REASON_CODES_BP = [
  "CF",
  "CF2",
  "CF3",
  "CL",
  "CL2",
  "CL3",
]


export const REASON_CODES_CCM = [
  "FS1",
  "FS2",
  "FS3",
  "FS4",
  "FS5",
  "FS6",
  "FS7",
  "FS8",
  "FS9",
  "F1",
  "F2",
  "F3",
  "F4",
  "F5",
  "F6",
  "F7",
  "F8",
  "F9",
  "CF",
  "CF2",
  "CF3",
  "CL",
  "CL2",
  "CL3",
  "FU1",
  "FU2",
  "FU3",
  "FU4",
  "FU5",
  "FU6",
  "FU7",
  "FU8",
  "FU9",
  "U01",
  "U02",
  "U03",
  "U04",
  "U05",
  "U06",
  "U07",
  "U08",
  "U09",
  "U10",
  "U11",
  "U12",
  "U13",
  "U14",
  "U15",
  "U16",
  "U17",
  "U18",
  "U19",
  "U20",
  "MP",
  "MIS",
  "TD",
];

export const VALIDATION_MSG_FIELD_EMPTY = " cannot be empty";

export const BP_EDITABLE = {
  newReasonCode: { type: "select", values: [], validation: {} },
  itemTextForExtendedAmount: { type: "text" },
  amountToExtend: {
    type: "currency",
    validation: { min: 0.01, max: ["amountInDocCurrency"] },
    errorMsg: {
      min: '"Amount to extend" cannot be less than "0.01"',
      max: '"Amount to extend" cannot be higher than the "Amount in Doc Currency"',
    },
  },
  newCalculatedDate: {
    type: "date",
    validation: { min: "today", max: ["originalDocDate", 730] },
    errorMsg: {
      min: '"New Calculated Due Date" cannot be in the past',
      max: '"New Calculated Due Date" exceeds 24 months from "original document date"',
    },
  },
  daysOfExtension: {
    type: "number",
    validation: { min: 1, max: 180 },
    errorMsg: {
      min: '"Days of Extension" cannot be negative apart from AP extension type',
      max: '"Days of Extension" exceeds 180 days from "Due Date For NetPayment"',
    },
  },
  commentFromBP: { type: "text-area" },
  commentSendToDealer: { type: "text-area" },
  originalDueDate: { type: "date", validation: {} },
  valuta: { type: "date", validation: {} },
  originalDocDate: {
    type: "date",
    validation: { max: "today" },
    errorMsg: {
      max: '"Original doc date" cannot be later than current date',
    },
  },
};

export const CCM_EDITABLE = {
  newReasonCode: { type: "select", values: [], validation: {} },
  newCalculatedDate: {
    type: "date",
    validation: { min: "today", max: ["originalDocDate", 730] },
    errorMsg: { min: '"New Calculated Due Date" cannot be in the past' },
    msg: {
      max: '"New Calculated Due Date" exceeds 24 months from "original document date"',
    },
  },
  amountToExtend: {
    type: "currency",
    validation: { min: 0.01, max: ["amountInDocCurrency"] },
    errorMsg: {
      min: '"Amount to extend" cannot be less than "0.01"',
      max: '"Amount to extend" cannot be higher than the "Amount in Doc Currency"',
    },
  },
  daysOfExtension: {
    type: "number",
    validation: { min: 1, max: 180 },
    errorMsg: { min: '"Days of Extension" cannot be in the past' },
    msg: {
      max: '"Days of Extension" exceeds 180 days from "Due Date For NetPayment"',
    },
  },
  downPaymentPercentage: {
    type: "currency",
    validation: { min: 0, max: 99 },
    errorMsg: {
      min: '"Down Payment Percentage" cannot be less than 0',
      max: '"Down Payment Percentage" cannot be more than 99 percent of "Amount In Doc Currency"',
    },
  },
  downPaymentAmount: {
    type: "currency",
    validation: {
      type: "percentage",
      min: ["amountInDocCurrency", 0],
      max: ["amountInDocCurrency", 99],
    },
    errorMsg: {
      min: '"Down Payment Amount" cannot be less than 0',
      max: '"Down Payment Amount" cannot be more than 99 percent of "Amount In Doc Currency"',
    },
  },
  commentSendToDealer: { type: "text-area" },
  originalDueDate: { type: "date", validation: {} },
  valuta: { type: "date", validation: {} },
  originalDocDate: {
    type: "date",
    validation: { max: "today" },
    errorMsg: {
      max: '"Original doc date" cannot be later than current date',
    },
  },
  commentSendToBP: { type: "text-area" },
  itemTextForExtendedAmount: { type: "text" },
};

export const IS_HIGHRISK = ["Yes", "No"];

export const COUNTRY_CODE_MAP = {
  FR: "France",
  DE: "Germany",
  IE: "Ireland",
  IT: "Italy",
  JD: "JDWIN",
  PL: "Poland",
  PT: "Portugal",
  ES: "Spain",
  GB: "UK",
};

export const COUNTRY_CODE = {
  FR: "FR",
  GB: "GB",
  Germany: "DE",
  Ireland: "IE",
  JDWIN: "JD",
  Poland: "PL",
  Portugal: "PT",
  Spain: "ES",
  Italy: "IT",
};

export const CODE_COUNTRY_IB = {
  France: "FR",
  UK: "GB",
  Germany: "DE",
  Ireland: "IE",
  Poland: "PL",
  Portugal: "PT",
  Spain: "ES",
  Italy: "IT",
  JDWIN: "JD",
};

export const CODE_COUNTRY_USER_PRF = {
  France: "FR",
  UK: "GB",
  Germany: "DE",
  Ireland: "IE",
  Poland: "PL",
  Portugal: "PT",
  Spain: "ES",
  Italy: "IT",
  JDWIN: "JD",
};

export const CODE_COUNTRY_FULL_NAME = {
  FR: "France",
  GB: "UK",
  DE: "Germany",
  IE: "Ireland",
  PL: "Poland",
  PT: "Portugal",
  ES: "Spain",
  IT: "Italy",
  JD: "JDWIN",
};

export const ALL_COUNTRIES_WITH_JDWIN = ["FR", "GB", "DE", "IE", "PL", "PT", "ES", "IT", "JD"];


export const COUNTRIES = [
  "FR",
  "GB",
  "DE",
  "IE",
  "BE",
  "CZ",
  "NL",
  "PL",
  "PT",
  "ES",
  "IT",
];

export const PRODUCT_CATEGORIES = [
  "Tractors",
  "Combines",
  "SPFH",
  "Balers",
  "Seeders",
  "AMS",
  "Platforms",
  "Front Loaders - AG",
  "Mocos",
  "Sprayers",
  "Turf",
  "Cotton Picker",
];

export const PRODUCT_TYPE_CATEGORIES = {
  Tractors: "Non-seasonal",
  Combines: "Seasonal",
  SPFH: "Seasonal",
  Balers: "Seasonal",
  Seeders: "Seasonal",
  AMS: "Non-seasonal",
  Platforms: "Seasonal",
  "Front Loaders - AG": "Non-seasonal",
  Mocos: "Seasonal",
  Sprayers: "Non-seasonal",
  Turf: "Turf",
  "Cotton Picker": "Seasonal",
};


export const dateFilterOperators = getGridStringOperators().map((operator) => ({
  ...operator,
  getApplyFilterFn: (filterItem) => {
    if (!filterItem.value) return null;
    
    return (cellValue) => {
      if (!cellValue) return false;
      
      // Convert stored date (YYYY-MM-DD) to display format (DD-MM-YYYY)
      const formattedDate = dayjs(cellValue, "YYYY-MM-DD").format("DD-MM-YYYY");
      
      const filterStr = String(filterItem.value).toLowerCase();
      const dateStr = String(cellValue).toLowerCase();
      const formattedStr = formattedDate.toLowerCase();
      
      // Apply operator logic - support both date formats
      switch (operator.value) {
        case 'contains':
          return formattedStr.includes(filterStr) || dateStr.includes(filterStr);
        case 'equals':
          return formattedStr === filterStr || dateStr === filterStr;
        case 'startsWith':
          return formattedStr.startsWith(filterStr) || dateStr.startsWith(filterStr);
        case 'endsWith':
          return formattedStr.endsWith(filterStr) || dateStr.endsWith(filterStr);
        case 'isEmpty':
          return !cellValue;
        case 'isNotEmpty':
          return !!cellValue;
        default:
          return true;
      }
    };
  },
}));

export const dateFilterFn = (row, columnId, filterValue) => {
  const cellValue = row.getValue(columnId);
   if (!cellValue || !filterValue) return true;
  
  // Convert stored date (YYYY-MM-DD) to both display formats
  const formattedDateDash = dayjs(cellValue, "YYYY-MM-DD").format("DD-MM-YYYY"); // 04-08-2026
  const formattedDateSlash = dayjs(cellValue, "YYYY-MM-DD").format("DD/MM/YYYY"); // 04/08/2026
  
  const filterStr = String(filterValue).toLowerCase();
  const dateStr = String(cellValue).toLowerCase();
  const formattedDashStr = formattedDateDash.toLowerCase();
  const formattedSlashStr = formattedDateSlash.toLowerCase();
  
  
  // Support filtering by all formats: DD-MM-YYYY, DD/MM/YYYY, and YYYY-MM-DD
  const result = formattedDashStr.includes(filterStr) || 
                 formattedSlashStr.includes(filterStr) || 
                 dateStr.includes(filterStr);
  
  return result;
};

export const CCM_COLUMNS = [
  {
    accessorKey: "requestStatus", //access nested data with dot notation
    header: "Request Status",
    size: 200,
    Cell: getStatusCell,
  },
  {
    accessorKey: "customerNo",
    header: "Customer No",
    size: 150,
  },
  {
    accessorKey: "customerName", //normal accessorKey
    header: "Name",
    size: 200,
  },
  {
    accessorKey: "assignmentNo",
    header: "Assignment Number",
    size: 50,
  },
  {
    accessorKey: "DocCurrency",
    header: "Currency",
    size: 200,
    Cell: getCurrencyCell,
  },
  {
    accessorKey: "amountInDocCurrency",
    header: "Amount In DocCurrency",
    size: 200,
    Cell: getAmountCell,
  },
  {
    accessorKey: "extensionType",
    header: "Extension Type",
    size: 50,
  },
  {
    accessorKey: "dueDateForNetPayment",
    header: "DueDate For NetPayment",
    size: 150,
    Cell: getDateCell,
    filterFn: dateFilterFn,
  },
];

export const BP_COLUMNS = [...CCM_COLUMNS];

export const LOG_COLUMNS = [...BP_COLUMNS];

const headerStyle = {
  whiteSpace: "normal",
  wordWrap: "break-word",
  textAlign: "center",
  padding: "8px",
  fontWeight: "bold",
};

export const EXTENSION_COLUMNS = [
  {
    field: "requestStatus",
    headerName: "Request Status",
    renderHeader: () => {
      return (
        <Typography variant="body2" style={headerStyle}>
          Request Status
        </Typography>
      );
    },
    width: 200,
    editable: false,
    renderCell: (params) => {
      return getStatusCell(params.row.requestStatus, {
        creditLimitExceeded: params.row.creditLimitExceeded
      });
    },
    filterable: true,
  },
  {
    field: "customerNo",
    headerName: "Customer No",
    renderHeader: () => {
      return <strong>Customer No</strong>;
    },
    width: 130,
    editable: false,
  },
  {
    field: "customerName",
    headerName: "Customer Name",
    renderHeader: () => {
      return <strong>Name</strong>;
    },
    width: 300,
    editable: false,
  },
  {
    field: "assignmentNo",
    headerName: "Assignment Number",
    renderHeader: () => {
      return (
        <Typography variant="body2" style={headerStyle}>
          Assignment Number
        </Typography>
      );
    },
    width: 150,
    editable: false,
    renderCell: (params) => {
      return (
        <AssignmentNumberCell 
          assignmentNo={params.row.assignmentNo}
        />
      );
    },
  },
  {
    field: "currencyKey",
    headerName: "Currency",
    renderHeader: () => {
      return (
        <Typography variant="body2" style={headerStyle}>
          Currency
        </Typography>
      );
    },
    width: 150,
    editable: false,
    renderCell: (params) => {
      return getCurrencyCell(
        params.row.currencyKey
      );
    },
  },
  {
    field: "amountInDocCurrency",
    headerName: "Amount In Doc Currency",
    renderHeader: () => {
      return (
        <Typography variant="body2" style={headerStyle}>
          Amount In DocCurrency
        </Typography>
      );
    },
    width: 150,
    editable: false,
    renderCell: (params) => {
      return getAmountCell(
        params.row.amountInDocCurrency,
        params.row.debitCreditIndicator,
      );
    },
  },
  {
    field: "extensionType",
    headerName: "Extension Type",
    renderHeader: () => {
      return (
        <Typography variant="body2" style={headerStyle}>
          Extension Type
        </Typography>
      );
    },
    width: 100,
    editable: false,
  },
  {
    field: "dueDateForNetPayment",
    headerName: "Due Date For Net Payment",
    renderHeader: () => {
      return (
        <Typography variant="body2" style={headerStyle}>
          DueDate For NetPayment
        </Typography>
      );
    },
    width: 150,
    editable: false,
    renderCell: (params) => {
      return getDateCell(params.row.dueDateForNetPayment);
    },
    filterOperators: dateFilterOperators,
  },
];

export const ERROR_COLUMNS = [
  ...BP_COLUMNS,
  {
    accessorKey: "errorMsg", //access nested data with dot notation
    header: "Error Message",
    size: 150,
  },
];

/** Table CONSTANTS STARTS */

export const DEPENDENT_FIELDS = {
  newCalculatedDate: "daysOfExtension", // Calcualate different in the "due date for net payment" & set date
  daysOfExtension: "newCalculatedDate", // "due date for net payment" + 80 = 20-MAY-2024
  downPaymentPercentage: "downPaymentAmount", // parse Int
  downPaymentAmount: "downPaymentPercentage", // amount / total net amount, round to 2 decimal
};

export const DEPENDENT_FIELDS_CCM = {
  newCalculatedDate: "daysOfExtension", // Calcualate different in the "due date for net payment" & set date
  daysOfExtension: "newCalculatedDate", // "due date for net payment" + 80 = 20-MAY-2024
  downPaymentPercentage: "downPaymentAmount", // parse Int
  downPaymentAmount: "downPaymentPercentage", // amount / total net amount, round to 2 decimal
  amountToExtend: "downPaymentAmount",
};

export const DEPENDENT_FIELDS_CALCULATION = {
  startDate: "endDate",
  endDate: "startDate",
};

export const BASE_CODE_ERROR = "BaseCode is not Present in Product Type";

// Query parameter constants
export const QUERY_PARAMS = {
  BASE_CODE: 'baseCode',
  AUTO_ADD: 'autoAdd',
  IS_PRODUCT: 'isProduct'
};

// Excel export columns for extension requests
export const EXTENSION_EXCEL_COLUMNS = [
  { field: "requestStatus", headerName: "Request Status", width: 22, type: "string" },
  { field: "customerNo", headerName: "Customer No", width: 15, type: "string" },
  { field: "customerName", headerName: "Name", width: 32, type: "string" },
  { field: "assignmentNo", headerName: "Assignment Number", width: 22, type: "string" },
  { field: "currencyKey", headerName: "Currency", width: 24, type: "string" },
  { field: "amountInDocCurrency", headerName: "Amount In DocCurrency", width: 24, type: "number" },
  { field: "extensionType", headerName: "Extension Type", width: 15, type: "string" },
  { field: "dueDateForNetPayment", headerName: "DueDate For NetPayment", width: 25, type: "date" },
  { field: "serialNo", headerName: "Serial Number", width: 22, type: "string" },
  { field: "reasonCode", headerName: "Current Reason Code", width: 22, type: "string" },
  { field: "presoldDate", headerName: "Presold Date", width: 18, type: "date" },
  { field: "longTextForDocLineItem", headerName: "Long Text For Document Line Item", width: 35, type: "string" },
  { field: "referenceContract", headerName: "Financing Reference", width: 25, type: "string" },
  { field: "commentSendToDealer", headerName: "Comment Send To Dealer", width: 25, type: "string" },
  { field: "commentSendToBP", headerName: "Comment Send To BP", width: 25, type: "string" },
  { field: "commentFromBP", headerName: "Comment From BP", width: 25, type: "string" },
];
export const EXTENSION_EXCEL_COLUMNS_LOGS = [{ field: "newReasonCode", headerName: "New Reason Code", width: 22, type: "string" },
  { field: "processingtime", headerName: "Date Processed", width: 20, type: "date" },
  { field: "userID", headerName: "Processed By", width: 18, type: "string" },]